export enum EventType {
  Bedrijfsopleiding = 914060000,
  Webinar = 914060001,
  Open_Inschrijving_Opleiding = 914060002,
  Bijeenkomst = 914060003,
  Raad = 914060004,
  Community = 914060005,
  Bedrijfsadvies = 914060006
}

export enum PriceType {
  MEMBER = 808930000,
  NONMEMBER = 808930001,
  EXAM = 123 // TODO: Add correct exam type
}

export interface EventTemplate {
  id: string
  name: string
  events: Event[]
  products: Product[]
}

export interface Event {
  id: string
  name: string
  sessions: Session[]
  products: Product[]
  eventType: EventType | null
  start_date: Date | null
  end_date: Date | null
  availableSeats: number
  city: string
}

export interface Session {
  id: string
  name: string
  description: string
  start_date: Date | null
  end_date: Date | null
  city: string
  teachers: string[]
}

export interface Product {
  price_type: PriceType | null
  amount: number | null
  additional_product: boolean
}

export interface Account {
  city: string
}
